export default {
  props: {
    microdata: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasMicrodata() {
      return !!this.microdata
        && !!this.microdata.title
        && !!this.microdata.description
        || !!this.$metaInfo
        || !!this.pageTitle
    },
    microdataTitle() {
      if (this.hasMicrodata) {
        if (this.microdata) {
          return this.microdata.title
        } else if (this.$metaInfo) {
          return this.pageTitle
        }
      }
      return ''
    },
    microdataDescription() {
      if (this.hasMicrodata) {
        if (this.microdata) {
          return this.microdata.description
        } else if (this.$metaInfo) {
          return this.$metaInfo.meta.find(item => item.name === 'description').content
        }
      }
      return ''
    },
    jsonProductMicrodata() {
      if (this.hasMicrodata) {
        return JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          'name': this.microdataTitle,
          'description': this.microdataDescription,
          'brand':
            {
              '@type': 'Thing',
              'name': 'Selectel'
            },
          'offers':
            {
              '@type': 'AggregateOffer',
              'lowPrice': this.microdataPrice,
              'priceCurrency': 'RUB'
            }
        })
      }
      return ''
    },
    microdataPrice() {
      return ''
    }
  }
}